import React from 'react';
import PropTypes from 'prop-types';
import checkIcon from 'icons/check.svg';
import closeIcon from 'icons/close-thin.svg';
import PIcheckIcon from 'src/components/atoms/Icons/svg/check.svg';
import PIcrossIcon from 'src/components/atoms/Icons/svg/cross.svg';
import Icon from 'components/Icon.jsx';
import classnames from 'classnames';
import { Text } from 'components/ui';

const PasswordValidationCheck = ({ label, showErrors, isValid, className, productIdentity }) => {
    const isPasswordValid = showErrors && isValid;
    const isPasswordInvalid = showErrors && !isValid;
    return (
        <div
            className={classnames(
                'passwordValidationElement',
                { 'passwordValidationElement--valid': isPasswordValid },
                { 'passwordValidationElement--invalid': isPasswordInvalid },
                { 'passwordValidationElement--neutral': !showErrors },
                'u-flexible-row',
                className
            )}
        >
            {isPasswordValid && (
                <Icon
                    className="u-flexible-row u-mr-1"
                    src={productIdentity ? PIcheckIcon : checkIcon}
                />
            )}
            {isPasswordInvalid && (
                <Icon
                    size="small"
                    className="u-flexible-row u-mr-1"
                    src={productIdentity ? PIcrossIcon : closeIcon}
                />
            )}
            {!showErrors && <div className="passwordValidationElementNeutralPoint u-mr-1" />}
            <Text>{label}</Text>
        </div>
    );
};

PasswordValidationCheck.propTypes = {
    label: PropTypes.string.isRequired,
    showErrors: PropTypes.bool,
    isValid: PropTypes.bool,
    className: PropTypes.string,
    productIdentity: PropTypes.bool,
};

export default PasswordValidationCheck;
